"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useElementWidth = void 0;
var _react = require("react");
var _lodash = require("lodash");
const getElementWidth = element => {
  if (element && element.offsetWidth) {
    return element.offsetWidth;
  } else {
    return 0;
  }
};
// This hook expects a ref and returns the current width of the ref
const useElementWidth = (elementRef, fallback) => {
  const [elementWidth, setElementWidth] = (0, _react.useState)(fallback);
  const updateWidth = () => {
    if ((0, _lodash.get)(elementRef, 'current')) {
      const currentElementWidth = getElementWidth(elementRef.current);
      if (currentElementWidth !== elementWidth) {
        setElementWidth(currentElementWidth);
      }
    } else {
      setElementWidth(fallback);
    }
  };
  (0, _react.useEffect)(() => {
    updateWidth();
    window.addEventListener('resize', updateWidth);
    return () => window.removeEventListener('resize', updateWidth);
  }, [getElementWidth(elementRef.current)]);
  return elementWidth;
};
exports.useElementWidth = useElementWidth;
//# sourceMappingURL=useElementWidth.js.map